export enum QuotationStatus {
  PENDING = "pending",
  COMPLETED = "completed",
}
